import React from 'react';
import { Tooltip } from 'antd';

export const formattedBigText = (text = '', maxLength = 30) => {  
    if (text.length > maxLength) {
        return <Tooltip title={text}>{`${text.substr(0, maxLength)}...`}</Tooltip>;
    }

    return text;
};